import { useNavigate } from 'react-router-dom';

import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';

const NewsNotFound = () => {
  const navigate = useNavigate();
  const menuName = usePageMenuName(PAGES.NEWS, __('News'));

  return (
    <SimpleCard
      faIconProps={{
        iconName: 'message-exclamation',
      }}
      title={s__('News|News not found')}
      description={s__('News|Sorry, this news was not found')}
      buttonProps={{
        children: s__('News|Go to %{name}').i__({
          name: menuName,
        }),
        onClick: () => navigate('..'),
      }}
    />
  );
};

export default NewsNotFound;
